export default __webpack_public_path__ + "static/hover-do-dark-f858e832d07ea305775253084470327b.png";